module.exports = __webpack_public_path__ + "img/medium.de53c802.png";